import React, { useState, useEffect } from 'react';

// Import Icons
import paginationLeftIcon from '../assets/images/icons/pagination-left-arrow.svg';
import paginationRightIcon from '../assets/images/icons/pagination-right-arrow.svg';

function TablePagination(props) {
    const totalResults = props.totalData, itemsPerPage = props.pageLimit;
    const [currentPage, setCurrentPage] = useState(1);

    // Calculate the total number of pages
    const totalPages = Math.ceil(totalResults / itemsPerPage);
    let skip, limit;
    // Handle page click
    useEffect(() => {
        skip = (Number(currentPage) * Number(itemsPerPage)) - Number(itemsPerPage);
        limit = Number(itemsPerPage)
        if (props?.otcTrade == 'true') {
            props.onPageChange(skip, limit);
        } else {
            props.onPageChange(currentPage);
        }

    }, [currentPage]);
    const handlePageClick = (page) => {

        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
        // console.log("calling page", currentPage)
        skip = (Number(currentPage) * Number(itemsPerPage)) - Number(itemsPerPage);
        limit = Number(itemsPerPage)
        // console.log(skip, limit)
        if (props?.otcTrade == 'true') {
            props.onPageChange(skip, limit);
        } else {
            props.onPageChange(currentPage);
        }

    };

    // Generate pagination buttons dynamically with ellipsis
    const paginationButtons = () => {
        let buttons = [];
        // Add "Previous" button if not on the first page
        if (currentPage > 1) {
            buttons.push(
                <li key="prev">
                    <a
                        href="#"
                        className="pagination-btn w-96 desktop"
                        onClick={() => handlePageClick(currentPage - 1)}
                    >
                        Previous
                    </a>
                    <a
                        href="#"
                        className="pagination-btn mobile"
                        onClick={() => handlePageClick(currentPage - 1)}
                    >
                        <img
                            src={paginationLeftIcon} // Add your icon path here
                            className="arrow-icon"
                            alt="icon"
                        />
                    </a>
                </li>
            );
        }

        // Handle the first few page numbers, ellipsis, and last few page numbers
        const startPage = Math.max(1, currentPage - 2);  // Start from 2 pages before the current page
        const endPage = Math.min(totalPages, currentPage + 2);  // End at 2 pages after the current page

        // Add the first few pages
        for (let i = startPage; i <= endPage; i++) {
            buttons.push(
                <li key={i}>
                    <a
                        href="#"
                        className={`pagination-btn ${currentPage == i ? 'active' : ''}`}
                        onClick={() => handlePageClick(i)}
                    >
                        {i}
                    </a>
                </li>
            );
        }

        // Add ellipsis (`...`) if necessary
        if (startPage > 1) {
            buttons.splice(0, 1,
                <li key="ellipsis-start">
                    <a href="#" className="pagination-btn no-border">...</a>
                </li>
            );
            buttons.unshift(
                <li key="prev">
                    <a
                        href="#"
                        className="pagination-btn w-96 desktop"
                        onClick={() => handlePageClick(currentPage - 1)}
                    >
                        Previous
                    </a>
                    <a
                        href="#"
                        className="pagination-btn mobile"
                        onClick={() => handlePageClick(currentPage - 1)}
                    >
                        <img
                            src={paginationLeftIcon} // Add your icon path here
                            className="arrow-icon"
                            alt="icon"
                        />
                    </a>
                </li>
            );

        }

        if (endPage < totalPages) {
            buttons.push(
                <li key="ellipsis-end">
                    <a href="#" className="pagination-btn no-border">...</a>
                </li>
            );
        }

        // Add "Next" button if not on the last page
        if (currentPage < totalPages) {
            buttons.push(
                <li key="next">
                    <a
                        href="#"
                        className="pagination-btn w-96 desktop"
                        onClick={() => handlePageClick(currentPage + 1)}
                    >
                        Next
                    </a>
                    <a
                        href="#"
                        className="pagination-btn mobile"
                        onClick={() => handlePageClick(currentPage + 1)}
                    >
                        <img
                            src={paginationRightIcon} // Add your icon path here
                            className="arrow-icon"
                            alt="icon"
                        />
                    </a>
                </li>
            );
        }


        return buttons;
    };

    return (
        <div className="pagination-wrapper-main">
            <div className="container">
                <div className="pagination-wrapper">
                    <p className="empty-tag"></p>
                    <ul className="pagination-list">
                        {paginationButtons()}
                    </ul>
                    <p className="show-result p w-600">
                        Showing {itemsPerPage} Results out of {totalResults}
                    </p>
                </div>
            </div>
        </div>
    );
}

export default TablePagination;
